<template>
  <div id="app">
    <SiteHeader :site="site" :navs="navs" />
    <router-view :site="site" />
    <SiteFooter :site="site" :navs="navs" />
    <FloatingConsult :phone="site.phone" :wechatQr="site.wechatQr" :wechatId="site.wechatId" />
  </div>
</template>

<script>
import { apiGet } from './api'
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import FloatingConsult from './components/FloatingConsult.vue'

export default {
  components: { SiteHeader, SiteFooter, FloatingConsult },
  data() {
    return {
      site: {},
      navs: []
    }
  },
  created() {
    apiGet('/api/site').then(data => {
      const site = {}
      ;(data.configs || []).forEach(item => { site[item.configKey] = item.configValue })
      this.site = site
      this.navs = data.navs || []
      if (site.companyName) {
        document.title = site.companyName + ' - 智慧医疗设备与解决方案提供商'
      }
      // 动态设置 SEO 元标签
      this.setMeta('description', site.siteDesc || '合肥中科厚生医疗科技有限公司是一家专注于智慧医疗设备研发、生产与销售的高新技术企业，提供医疗器械、医疗信息化、健康管理等全方位医疗解决方案。')
      this.setMeta('keywords', site.siteKeywords || '合肥中科厚生,中科厚生,医疗科技,医疗器械,医疗设备,智慧医疗,数字医疗,医疗信息化,健康管理,医疗解决方案')
      // 动态覆盖主题色
      if (site.themeMain) document.documentElement.style.setProperty('--main', site.themeMain)
      if (site.themeDeep) document.documentElement.style.setProperty('--deep', site.themeDeep)
      if (site.themeAccent) document.documentElement.style.setProperty('--accent', site.themeAccent)
    })
  },
  methods: {
    setMeta(name, content) {
      if (!content) return
      let meta = document.querySelector('meta[name="' + name + '"]')
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', name)
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    }
  }
}
</script>

